export const FIREBASE_CONFIG = {
    apiKey: 'AIzaSyAXrp9C1aRpteNX2ksiDzbD_d0h1BlgvJ8',
    authDomain: 'chckup-server-dev.firebaseapp.com',
    projectId: 'chckup-server-dev',
    storageBucket: 'chckup-server-dev.appspot.com',
    messagingSenderId: '422357030216',
    appId: '1:422357030216:web:0b9d0877b366683c8bcf7d',
    measurementId: 'G-S9CQESMGL3',
}
